import { ACADEMY_ENABLED, INVESTOR_PROFILE_ENABLED } from "../constants/features";

const ALL_QA = [
  // ─── תחילת עבודה ──────────────────────────────────────────────────────────
  {
    id: "onboard-1",
    category: "תחילת עבודה",
    categoryIcon: "rocket",
    question: "איך נרשמים למערכת?",
    answer: "לחץ על 'הרשמה' בדף הכניסה, הזן כתובת אימייל וסיסמה (לפחות 6 תווים). לאחר הרשמה תקבל אימייל אימות · לחץ על הקשר בתוכו כדי לאמת את החשבון. לאחר האימות תוכל להיכנס ישירות.",
  },
  {
    id: "onboard-2",
    category: "תחילת עבודה",
    categoryIcon: "rocket",
    question: "איך מוסיפים מניה ראשונה לפורטפוליו?",
    answer: "בדף 'פורטפוליו' לחץ על כפתור '+'. הזן את סימול המניה (למשל AAPL לאפל, NVDA לאנבידיה), מספר המניות ומחיר הקנייה. לחץ 'הוסף' · המניה תופיע מיד עם נתוני מחיר בזמן אמת.",
  },
  {
    id: "onboard-3",
    category: "תחילת עבודה",
    categoryIcon: "rocket",
    question: "האם יש שאלון הגדרת פרופיל?",
    answer: "כן. בהפעלה ראשונה האפליקציה מציגה שאלון קצר (כ-2 דקות) שמגדיר את פרופיל המשקיע שלך: ניסיון, אופק השקעה ויחס לסיכון. המידע הזה מעדכן את הניתוחים. ניתן לאפס את הפרופיל בכל עת מדף ההגדרות.",
  },

  // ─── פורטפוליו ────────────────────────────────────────────────────────────
  {
    id: "portfolio-1",
    category: "תיק",
    categoryIcon: "chart",
    question: "איך עורכים החזקה קיימת?",
    answer: "כרגע העריכה הישירה אינה נתמכת · הדרך היא למחוק את המניה ולהוסיף אותה מחדש עם הנתונים הנכונים. אנחנו עובדים על פיצ'ר עריכה מלא שיגיע בגרסה הבאה.",
  },
  {
    id: "portfolio-2",
    category: "תיק",
    categoryIcon: "chart",
    question: "איך מוחקים מניה מהפורטפוליו?",
    answer: "לחץ על המניה ברשימה כדי לפתוח את הפאנל שלה. גלול לתחתית הפאנל ולחץ 'מחק מהפורטפוליו' (או 'Remove'). המחיקה היא מיידית וסופית · הנתונים מוסרים גם מהשרת.",
  },
  {
    id: "portfolio-3",
    category: "תיק",
    categoryIcon: "chart",
    question: "איך רואים רווח/הפסד על כל החזקה?",
    answer: "בדף הפורטפוליו כל מניה מציגה רווח/הפסד בשקלים ובאחוזים לצד מחיר הקנייה והמחיר הנוכחי. הסכום הכולל מוצג בראש הדף. מספרים ירוקים = רווח, אדומים = הפסד.",
  },
  {
    id: "portfolio-4",
    category: "תיק",
    categoryIcon: "chart",
    question: "האם אפשר לייצא את הנתונים?",
    answer: "כן. בדף ההגדרות → 'ייצוא נתונים' → 'ייצוא CSV'. הקובץ כולל: סמל, שם, כמות, מחיר קנייה, מחיר נוכחי, רווח/הפסד ואחוז מהתיק. ניתן גם להדפיס/שמור כ-PDF.",
  },

  // ─── ניתוחי AI ────────────────────────────────────────────────────────────
  {
    id: "ai-1",
    category: "מודיעין שוק",
    categoryIcon: "ai",
    question: "מה מציג מסך מודיעין השוק?",
    answer: "עד שלוש התפתחויות מהשבוע האחרון שנוגעות לחברות שבתיק שלך, כל אחת עם מה קרה, מה חדש, מה עוד לא ידוע, האירוע הבא ביומן והמקורות. ההתפתחויות נבנות פעמיים ביום מחדשות החברה ב-Finnhub. Google Gemini כותב את התיאור, וקוד בודק כל משפט מול הכתבות. הבחירה נעשית בקוד, לפי משקל ההחזקה וסוג האירוע, והציון לא מוצג. בהמשך הדף: נושאים פתוחים והמודיעין הגיאופוליטי. בלי מחירים ומדדים, בלי ציון מסוכם ובלי המלצה.",
  },
  {
    id: "ai-2",
    category: "מודיעין שוק",
    categoryIcon: "ai",
    question: "האם יש 'ציון AI' למניה?",
    answer: "לא. אין ציון מספרי מסוכם, אין דירוג פנימי שלנו, ולא מוצגים דירוגי אנליסטים או מחירי יעד. המידע מוצג כעובדות עם מקור ותאריך. כשאין נתון זמין ממקור חי, נאמר שאין · בלי להמציא.",
  },

  // ─── אקדמיה ומבחן ─────────────────────────────────────────────────────────
  {
    id: "academy-1",
    category: "אקדמיה ומבחן",
    categoryIcon: "academy",
    question: "מה יש באקדמיה?",
    answer: "שבעה מסלולים של שיעורים קצרים, מילון מושגים ומבחן. לכל נתון בשיעורים יש מקור עם קישור ותאריך בדיקה, וזמן הקריאה של כל שיעור מחושב ממספר המילים בו. האקדמיה מסבירה מושגים ואת האפליקציה עצמה · היא לא ממליצה על השקעה.",
  },
  {
    id: "academy-2",
    category: "אקדמיה ומבחן",
    categoryIcon: "academy",
    question: "איך עובד המבחן?",
    answer: "המבחן כולל שאלות בחירה מכל המסלולים. סדר התשובות מתערבב בכל הצגה. אחרי כל תשובה מופיע הסבר עם הפניה לשיעור, ובסוף מופיע מספר התשובות הנכונות. אין תעודה ואין דירוג.",
  },
  {
    id: "academy-3",
    category: "אקדמיה ומבחן",
    categoryIcon: "academy",
    question: "האם ניתן לחזור על המבחן?",
    answer: "כן, בכל עת, בכפתור 'מבחן חוזר'. התוצאה של הפעם האחרונה, והשיעורים שסומנו כנקראו, נשמרים במכשיר הזה בלבד.",
  },

  // ─── יומן ─────────────────────────────────────────────────────────────────
  {
    id: "calendar-1",
    category: "יומן",
    categoryIcon: "calendar",
    question: "איך לקרוא את היומן?",
    answer: "היומן מציג שלושה סוגי אירועים ב-30 הימים הקרובים: דוחות רבעוניים של החזקות בתיק, פרסומי מאקרו (CPI, תעסוקה, תוצר, PCE), וימים ללא מסחר בארה\"ב. נקודת הצבע ליד כל יום מציינת את סוג האירוע. לצד כל אירוע מוצגת תגית חפיפה לתיק שלך: בתיק שלך · במעקב שלך · בסקטור שלך · ללא חפיפה. אין דירוג חשיבות או השפעה · דירוג כזה היה הערכה שלנו, ואנחנו מתארים ולא מעריכים.",
  },
  {
    id: "calendar-2",
    category: "יומן",
    categoryIcon: "calendar",
    question: "האם ניתן להוסיף אירועים אישיים ליומן?",
    answer: "כרגע היומן מציג רק אירועים כלכליים גלובליים. הוספת אירועים אישיים (כגון תזכורות קנייה/מכירה) מתוכננת לגרסה עתידית. בינתיים, השתמש בהתראות המחיר כתחליף.",
  },
  {
    id: "calendar-3",
    category: "יומן",
    categoryIcon: "calendar",
    question: "לאיזה חודש מציג היומן את האירועים?",
    answer: "היומן מציג את החודש הנוכחי ברירת מחדל. ניתן לנווט קדימה ואחורה בחודשים באמצעות החצים בכותרת היומן. לחיצה על 'ראה עוד' על יום פעיל תפתח את כל האירועים לאותו יום.",
  },

  // ─── חשבון ופרופיל ─────────────────────────────────────────────────────────
  {
    id: "account-1",
    category: "חשבון ופרופיל",
    categoryIcon: "person",
    question: "איך מחליפים תמונת פרופיל?",
    answer: "עבור לדף 'הגדרות'. בראש הדף תראה את עיגול הפרופיל שלך עם אייקון מצלמה. לחץ על האייקון או על 'החלף תמונת פרופיל' ובחר קובץ JPG/PNG/WEBP עד 2MB. התמונה נשמרת בחשבון שלך.",
  },
  {
    id: "account-2",
    category: "חשבון ופרופיל",
    categoryIcon: "person",
    question: "איך משנים את שפת הממשק?",
    answer: "לחץ על דגל 🇮🇱 לעברית או 🇺🇸 לאנגלית · הכפתורים נמצאים בכותרת העליונה של האפליקציה. שינוי השפה מיידי ומשפיע על כל הדפים. ניתן גם לשנות דרך הגדרות → 'שפה'.",
  },
  {
    id: "account-3",
    category: "חשבון ופרופיל",
    categoryIcon: "person",
    question: "איך משנים את מטבע ברירת המחדל?",
    answer: "בדף 'הגדרות' → 'מטבע'. בחר USD (דולר), ILS (שקל) או EUR (אירו). השינוי מיידי ומשפיע על כל תצוגות המחיר והרווח/הפסד באפליקציה.",
  },

  // ─── בעיות נפוצות ─────────────────────────────────────────────────────────
  {
    id: "issues-1",
    category: "בעיות נפוצות",
    categoryIcon: "settings",
    question: "הנתונים לא מתעדכנים · מה לעשות?",
    answer: "1. רענן את הדף (Ctrl+R / Cmd+R). 2. בדוק שיש חיבור אינטרנט פעיל. 3. המחירים מתעדכנים כל 5 דקות · המתן מעט. אם הבעיה נמשכת: נסה לצאת ולהיכנס מחדש, או נקה את cache הדפדפן (Ctrl+Shift+Delete).",
  },
  {
    id: "issues-2",
    category: "בעיות נפוצות",
    categoryIcon: "settings",
    question: "שכחתי את הסיסמה · איך מאפסים?",
    answer: "בדף הכניסה, מתחת לשדה הסיסמה, לחץ על 'שכחתי סיסמה'. הזן את כתובת האימייל של החשבון ולחץ 'שלח קישור לאיפוס'. אם קיים חשבון עם הכתובת הזו יישלח אליה קישור · לחיצה עליו פותחת מסך לבחירת סיסמה חדשה. הקשר חד-פעמי ותקף לזמן מוגבל. בדוק גם בתיקיית 'ספאם' אם האימייל לא מגיע.",
  },
  {
    id: "issues-3",
    category: "בעיות נפוצות",
    categoryIcon: "settings",
    question: "הפורטפוליו שלי נעלם · מה קרה?",
    answer: "כנראה שנכנסת עם כתובת אימייל שונה. בדוק שאתה מחובר עם אותה כתובת שאיתה נרשמת. אם הבעיה נמשכת · צא מהחשבון, כנס מחדש, ואם הנתונים עדיין חסרים צור קשר בכתובת nagardavid88@gmail.com.",
  },
];

// The Academy's questions are left out while it is hidden (constants/features.js).
// Hidden screens (constants/features.js) take their Q&A entries with them:
// the Academy's category, and the entry that describes the questionnaire.
export const QA_DATA = ALL_QA
  .filter(q => ACADEMY_ENABLED || q.category !== "אקדמיה ומבחן")
  .filter(q => INVESTOR_PROFILE_ENABLED || q.id !== "onboard-3");

export const QA_CATEGORIES = [...new Set(QA_DATA.map(q => q.category))];
